import { trimSpaces } from "../helpers/textTransform";
import { statusProjectSemaforo } from "./statusProject";

export const colorInternalGraph = [
	{ name: "INMERSYS - DISEÑO UI/UX", color: "#FF4081" },
	{ name: "INMERSYS - ARTE 3D", color: "#7C4DFF" },
	{ name: "INMERSYS - UNITY", color: "#02BCD4" },
	{ name: "INMERSYS - WEB", color: "#2ECD6F" },
    { name: "DISEÑO UI/UX", color: "#FF4081" },
    { name: "ARTE 3D", color: "#7C4DFF" },
    { name: "UNITY", color: "#02BCD4" },
    { name: "WEB", color: "#2ECD6F" },
	{ name: "OPERACIONES", color: "#940bab" },
	{ name: "RH", color: "#C4E82E" },
	{ name: "Vacaciones", color: "#FFC300" },
	{ name: "COMERCIAL", color: "#2EE8CE" },
	{ name: "ADMINISTRACION", color: "#E4404B" },
	{ name: "Interno - ClickAPI", color: "#5F60BD" },
	{ name: "Interno - VR Training", color: "#5F60BD" },
	{ name: "Interno - VR Training", color: "#FFC300" },
];

export const colorAreas = [
	{ name: "Diseño UI/UX", color: "#FF4081" },
	{ name: "Arte 3D", color: "#7C4DFF" },
	{ name: "Programación Unity", color: "#02BCD4" },
	{ name: "Programación Web", color: "#2ECD6F" },
	{ name: "PLANEACIÓN", color: "#940bab" },
];

export const colorSemaforo = [
	{ index: 0, name: statusProjectSemaforo.green, color: "#8DC881" },
	{ index: 1, name: statusProjectSemaforo.yellow, color: "#E2CA64" },
	{ index: 2, name: statusProjectSemaforo.red, color: "#FF9543" },
	{ index: 3, name: statusProjectSemaforo.super_red, color: "#E9656E" },
	{ index: 4, name: statusProjectSemaforo.purple, color: "#9670FF" },
];

export const colorsSizeProject = [
	{ name: "xs", color: "#ACF6EC", hourRange: "0-80" },
	{ name: "s", color: "#5AEDD9", hourRange: "81-150" },
	{ name: "m", color: "#19E3C8", hourRange: "151-350" },
	{ name: "l", color: "#16CAB2", hourRange: "351-500" },
	{ name: "xl", color: "#119786", hourRange: "+500" },
	{ name: "xxl", color: "#0E7E6F", hourRange: "+1000" },
	{ name: "f", color: "#A3A3A3", hourRange: "Streaming" },
	{ name: "e", color: "#074038", hourRange: "Servicio" },
];

export const orderingLeaderColors = [
	{
		name: "daniela Burri",
		color: "#BF4ACC",
		child: colorsSizeProject,
	},
	{
		name: "diego Bernal",
		color: "#0918EC",
		child: colorsSizeProject,
	},
	{
		name: "Jocelyn Montiel",
		color: "#40BC86",
		child: colorsSizeProject,
	},
	{
		name: "Daphne Sánchez",
		color: "#3498DB",
		child: colorsSizeProject,
	},
	{
		name: "Pamela Chávez",
		color: "#4385f5",
		child: colorsSizeProject,
	},
	{
		name: "María José Villagomez",
		color: "#00D717",
		child: colorsSizeProject,
	},
	{
		name: "Erika Chong",
		color: "#FCB410",
		child: colorsSizeProject,
	},
	{
		name: "Carlos Coazozon",
		color: "#F31D2F",
		child: colorsSizeProject,
	},
	{
		name: "Emmanuel Alexis Perales Bernal",
		color: "#DF5E2A",
		child: colorsSizeProject,
	},
];
export const orderingClasificationProject = [
	{
		name: "AR",
		color: "#FFC300",
		child: [
			{ name: "app", color: "#FFDB66" },
			{ name: "app (móvil/escritorio)", color: "#FFDB66" },
			{ name: "filtros", color: "#FFE799" },
			{ name: "web", color: "#E6B000" },
		],
	},
	{
		name: "VR",
		color: "#FF7915",
		child: [
			{ name: "3d", color: "#FFCAA1" },
			{ name: "360", color: "#FF9543" },
			{ name: "360°", color: "#FF9543" },
			{ name: "rebrandeable", color: "#FFAF72" },
			{ name: "rebrandeables", color: "#FFAF72" },
		],
	},
	{
		name: "WEB",
		color: "#4385F5",
		child: [
			{ name: "3d", color: "#689CF7" },
			{ name: "3D", color: "#689CF7" },
			{ name: "360", color: "#8EB5F9" },
			{ name: "360°", color: "#8EB5F9" },
			{ name: "sin XR", color: "#B3CEFB" },
			{ name: "sin XR (plana)", color: "#B3CEFB" },
		],
	},
	{
		name: "OTRO",
		color: "#9900FF",
		child: [
			{ name: "video", color: "#AD33FF" },
			{ name: "mapping", color: "#8A00E6" },
			{ name: "otro", color: "#D699FF" },
			{ name: "app sin xr", color: "#25A359" },
			{ name: "aplicación sin xr (plana)", color: "#25A359" },
		],
	},
];

export const colorCurrency = [
	{ name: "MXN", color: "#C9CD6A" },
	{ name: "USD", color: "#2ECD6F" },
];

export const colorsPercentProject = {
	inProcess: {
		name: "En proceso",
		color: "#8DC881",
	},
	acceptable: {
		name: "Aceptable",
		color: "#E2CA64",
	},
	attention: {
		name: "Atención",
		color: "#FF9543",
	},
	exceeded: {
		name: "Excedido",
		color: "#E9656E",
	},
	overflowed: {
		name: "Desbordado",
		color: "#9670FF",
	},
};

export const getColorByConsume = (consume = 0) => {
	let color = colorsPercentProject["inProcess"].color;
	if (consume >= 70 && consume <= 100) {
		color = colorsPercentProject["acceptable"].color;
	} else if (consume > 100 && consume <= 115) {
		color = colorsPercentProject["attention"].color;
	} else if (consume > 115 && consume <= 200) {
		color = colorsPercentProject["exceeded"].color;
	} else if (consume > 200) {
		color = colorsPercentProject["overflowed"].color;
	}
	return color;
};

const findIndexCompress = (array = [], nameComparative = "") => {
	return array.findIndex((json) => trimSpaces(json.name) === trimSpaces(nameComparative));
};

export const colorsSunbursts = (arrays = [], colorsJson = []) => {
	return arrays.map((array) => {
		const findIndexFather = findIndexCompress(colorsJson, array.name);
		if (findIndexFather >= 0) {
			array.color = colorsJson[findIndexFather].color;
			array.children.map((element) => {
				const findIndexChild = findIndexCompress(colorsJson[findIndexFather].child, element.name);
				if (findIndexChild >= 0) {
					element.color = colorsJson[findIndexFather].child[findIndexChild].color;
				}
				return element;
			});
		}
		return array;
	});
};
export const colorsLeaderTable = (arrays, colorsJson) => {
	return arrays.map((array) => {
		const leaderColor = colorsJson.find((leader) => leader.name === array.leader)?.color;
		if (leaderColor) {
			array.color = leaderColor;
		} else {
			array.color = "#CCCCCC";
		}
		return array;
	});
};

export const colorsPieChart = (arrays = [], colorsJson = []) => {
	return arrays.map((array) => {
		const findIndexFather = findIndexCompress(colorsJson, array.id);
		if (findIndexFather >= 0) {
			array.color = colorsJson[findIndexFather].color;
		}
		return array;
	});
};
export const hoursRangePieChart = (arrays = [], colorsJson = []) => {
	return arrays.map((array) => {
		const findIndexFather = findIndexCompress(colorsJson, array.id);
		if (findIndexFather >= 0) {
			array.hourRange = colorsJson[findIndexFather].hourRange;
		}
		return array;
	});
};

export const sunburstsInit = { name: "categorias", children: [] };
